import jhsfBookingsApi from '../apis/jhsfBookingsApi';

const deleteUserAvatarsService = async (userId: string): Promise<void> => {
  await jhsfBookingsApi.delete(`/avatars/users/${userId}`);
};

export default deleteUserAvatarsService;
